module.exports = __webpack_public_path__ + "static/img/14000642.939a4856.png";